import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const NavContainer = styled.div`
  display: flex;
  background: white;
  border-radius: 8px;
  border: 1px solid ${colors.text['disabled-300']};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 41px;
  width: 599px;
  overflow: auto;
`;

export const NavItem = styled.button<{ isActive: boolean }>`
  flex: 1;
  padding: 0 16px;
  border: none;
  background: ${(props) => (props.isActive ? colors.brand.principal : colors.text['white-0'])};
  color: ${(props) => (props.isActive ? colors.text['white-0'] : colors.text['sub-500'])};
  font-weight: ${(props) => (props.isActive ? '600' : '400')};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-right: 1px solid ${colors.bg['soft-200']};
  position: relative;

  &:hover {
    background: ${(props) => (props.isActive ? colors.brand.primary.dark : '#f8f9fa')};
  }

  white-space: nowrap;

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    border-right: none;
  }
`;
